<template>
  <div class="wrapper">
    <van-nav-bar :title="this.$route.query.name" left-arrow @click-left="$router.go(-1)">
      <span slot="right" @click="search">
        <i class="iconfont icon-sousuo1"></i>
      </span>
    </van-nav-bar>
    <!-- <div class="title">{{$route.query.name}}</div> -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      class="model-list"
    >
      <ul class="model-wrapper">
        <li
          v-for="(item, index) in list"
          class="model-item"
          :key="index"
          @click="BrowseModel(item)"
        >
          <img :src="item.thumbnail | thumbnailGem(340,340)">
          <div class="model-name">{{item.name}}</div>
        </li>
      </ul>
    </van-list>
  </div>
</template>

<script>
import { NavBar, List, Toast } from "vant";
import { modelList } from "@/api/modelReq";

export default {
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Toast.name]: Toast
  },
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      finished: false,
      error: false
    };
  },

  methods: {
    onLoad() {
      this.page++;
      this.loading = true;
      modelList({ page: this.page, categoryId: this.$route.query.id })
        .then(res => {
          for (let i = 0; i < res.list.length; i++) {
            this.list.push(res.list[i]);
          }
          this.loading = false;
          if (res.total < res.page * res.pageSize) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    BrowseModel(item) {
      if (item.isAlbum) {
        this.$router.push({
          path: `/model-view/${item.id}`
        });
      }
      this.$router.push({
        path: `/model-view/${item.id}`
      });
    },
    search() {
      this.$router.push({
        path: "/search",
        query: {
          category: "gem"
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.wrapper {
  /deep/.van-nav-bar {
    background: transparent;
  }
  /deep/ .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  /deep/.van-icon {
    color: rgba(65, 65, 65, 1);
  }
  /deep/.van-nav-bar__text {
    font-weight: 400;
    color: rgba(65, 65, 65, 1);
  }
  /deep/.van-nav-bar__left {
    font-size: 18px;
  }
  /deep/.van-nav-bar__arrow {
    font-size: 20px;
  }
  .title {
    padding: 0 14px;
    margin-top: 20px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    font-size: 18px;
  }
  .model-list {
    margin-top: 20px;
    padding: 0 14px;
    .model-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .model-item {
        width: 49%;
        height: auto;
        margin-bottom: 8px;
        text-align: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 2px 3px 6px 0px rgba(66, 83, 103, 0.05);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        img {
          width: 100%;
          height: 45.34vw;
          vertical-align: middle;
        }
        .model-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          text-align: left;
          color: rgba(51, 51, 51, 1);
          font-size: 14px;
          font-weight: 400;
          padding: 8% 0 7% 9%;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
